var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-not-available"},[_c('PreviewNotAvailableSm',{staticClass:"preview-not-available__img preview-not-available__img--sm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }